const model = {
    tourMaxPrice: null,
    accommodationMaxPrice: null,
    loading: false,
    error: null,
};

export default model;
